(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-personalization"]) return;
  try {
    
(function() {
	function loadAsync() {
		var lazyimgs = document.querySelectorAll( '[data-lazy]' ),
			attrswap = function( img ) {
				img.src = img.getAttribute( 'data-src' );
				img.parentElement.classList.add( "class", "shown" );
			},
			supports = "IntersectionObserver" in window 
					&& "IntersectionObserverEntry" in window 
					&& "intersectionRatio" in window.IntersectionObserverEntry.prototype;

		if( supports ) {
			var imgObs = new IntersectionObserver( function( els, obs ) {
				els.forEach( function( el ) {
					if( el.isIntersecting ) {
						var img = el.target;

						attrswap( img );
						imgObs.unobserve( img );
					}
				});
			});

			[].slice.call( lazyimgs ).forEach(function(lazyimg) {
				lazyimg.parentElement.classList.add( 'fadein' );
				imgObs.observe( lazyimg );
			});
		} else {
			for( i = 0; i < lazyimgs.length; i++ ){
				attrswap( lazyimgs[ i ] );
			}
		}
	};

	document.addEventListener( "DOMContentLoaded", loadAsync );
	document.addEventListener( "loadAsyncImages", loadAsync );
}());

  } catch(e) { console.error(e); }
})();
})();
